import React, { useState, useEffect } from 'react'
import axios from 'axios'
import uuid from 'uuid/v4'
import { Carousel } from 'react-responsive-carousel'

import ErrorComponent from '../Error'
import LoadingComponent from '../Loading'

import helpers from '../utils/helpers'
import '../styles/carousel.css'
import '../styles/fpren.css'
import '../styles/fpren_hourly.css'

function chunk(arr, size) {
  return arr.reduce((acc, _, i) => (i % size) ? acc : [...acc, arr.slice(i, i + size)], [])
}

export default function Hourly({ userLocation }) {

  const [ hourly, setHourly ] = useState([])
  const [ error, setError ] = useState(null)
  const [ isLoaded, setIsLoaded ] = useState(false)
  const [ lat, lon ] = userLocation

  useEffect(() => {

    axios.get(`https://pbsweather.org/shared/server/udfd_hourly.php?lat=${lat}&lon=${lon}&hours=24`)
      .then(
        res => {
          setIsLoaded(true)
          const data = res.data.ndfd_hourly.data
          let hourlyForecast = []
          data.forEach(hour => {
            hourlyForecast.push({
              id: uuid(),
              time: helpers.convertToTime(hour.valid_begin ? hour.valid_begin : 'N/A').withoutMins,
              weatherCode: helpers.getMetarIcon(
                hour.weather_code ? hour.weather_code.value : 'N/A',
                hour.hasOwnProperty('daylight') ? hour.daylight : true
              ),
              weather: hour.weather_code ? hour.weather_code.text : 'N/A',
              temperature: helpers.convertTemperature(hour.temperature ? hour.temperature.value : 'N/A').fahrenheit,
              pop: hour.precipitation ? hour.precipitation.probability.value : 'N/A'
            })
          })
          // Set state in 6 forecast hours per array for easy use in carousel
          setHourly(chunk(hourlyForecast, 6))
        },
        error => {
          setIsLoaded(true)
          setError(error)
      })

  }, [ lat, lon ])

  if (error) return <ErrorComponent />
  if (!isLoaded) return <LoadingComponent />

  return (
    <Carousel showThumbs={false}>
      {hourly.map(chunk => {
        return (
          <div key={uuid()} className='panel-wrap panel-wrap-hourly-padding'>
            {chunk.map(hour => {
              return (
                <div key={hour.id} className='panel leftone'>
                  <p className='hourlylabel day'>{hour.time}</p>
                  <img className='hourlyicon' src={hour.weatherCode} alt='Weather Icon'></img>
                  <p className='hourlyphrase hourly'>{hour.weather}</p>
                  <p className='hourlytemp'>{hour.temperature}&deg;</p>
                  <p className='hourlypop'>{hour.pop}%</p>
                </div>
              )
            })}
          </div>
        )
      })}
    </Carousel>
  )
}
